import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ExperienceLevel = 'beginner' | 'intermediate' | 'expert';

export interface ExperienceLevelState {
  level: ExperienceLevel;
  hasBeenSet: boolean;
  setLevel: (level: ExperienceLevel) => void;
  isBeginner: () => boolean;
}

export const useExperienceLevel = create<ExperienceLevelState>()(
  persist(
    (set, get) => ({
      level: 'beginner' as ExperienceLevel,
      hasBeenSet: false,
      setLevel: (level) => set({ level, hasBeenSet: true }),
      isBeginner: () => get().level === 'beginner',
    }),
    { name: 'loki-experience-level' },
  ),
);
